import React from 'react';
import { styled } from '@elliemae/ds-legacy-system';
interface PopoverArrowT {
  placement: string;
  style: React.CSSProperties;
  arrowElementRef: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
}
const arrowWidth = 18;
const arrowHeight = 18;

const StyledArrow = styled.div<{ 'data-placement': string }>`
  position: absolute;
  width: ${arrowWidth}px;
  height: ${arrowHeight}px;
  pointer-events: none;
  background-color: transparent;
  & .stroke {
    fill: neutral-500;
    fill-opacity: 0.4;
  }
  & .fill {
    fill: neutral-000;
  }

  &[data-placement^='top'] {
    svg {
      transform: rotateZ(180deg);
    }
    bottom: -${arrowHeight}px;
  }
  &[data-placement^='right'] {
    svg {
      transform: rotateZ(-90deg);
    }
    left: -${arrowWidth}px;
  }
  &[data-placement^='bottom'] {
    top: -${arrowHeight}px;
  }
  &[data-placement^='left'] {
    svg {
      transform: rotateZ(90deg);
    }
    right: -${arrowWidth}px;
  }
  margin-left: ${(props) =>
    props['data-placement'].startsWith('top') || props['data-placement'].startsWith('bottom')
      ? `-${arrowWidth / 2}px;`
      : '0;'};
  margin-top: ${(props) =>
    props['data-placement'].startsWith('left') || props['data-placement'].startsWith('right')
      ? `-${arrowHeight / 2}px;`
      : '0;'};
`;

export const PopoverArrow = ({ placement, style, arrowElementRef }: PopoverArrowT): React.ReactElement => (
  <StyledArrow
    key="popper-arrow"
    data-placement={placement}
    style={style}
    ref={arrowElementRef}
    data-testid="ds-tooltip-arrow"
    aria-hidden="true"
  >
    <svg viewBox="0 0 30 30">
      <path
        className="stroke"
        d="M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26
        C26.7,29,24.6,28.1,23.7,27.1z"
      />
      <path
        className="fill"
        d="M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
      />
    </svg>
  </StyledArrow>
);
